<div class="outer_div">
  <label>Under Construction</label>
</div>
  <!--<div *ngIf="loadingspinner == true" class="spin"></div>
  <fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
    <div class="outer_div" *ngIf="token">
      <div class="mainsec">
        <div class="content">
          <img src="" class="logo" style="width: 103px;" *ngIf="flag != '48397'" />
        </div>
        <div class="add-money shadow">
          <h2 style="text-decoration: underline; color: #356394;">Add Money</h2>
          <div class="col-md-12">
            <div class="row no-gutters">
              <div class="col-12 form-padding">
                <form class="example-form" (ngSubmit)="AddmobileMoneyForm(AddMoneyForm.value)"
                      [formGroup]="AddMoneyForm">
                  <div class="row no-gutters">
                    <div class="col-md-12">
                      <div class="row no-gutters">

                        <div class="col-12">
                          <mat-radio-group class="example-radio-group" formControlName="PaymentModeCode">
                            <mat-radio-button *ngFor="let x of OptionList" [value]="x.code" (change)="changeMethod($event);">{{x.name}}</mat-radio-button>
                          </mat-radio-group>
                        </div>

                        <div class="col-12">

                          <div class="row payable-amount">
                            <div class="col-3 text-left" *ngIf="amt">
                              <p><b>Amount(USD)</b></p>
                              <p>{{this.stringJson.amount|number}}
                            </div>
                            <div class="col-3 text-left" *ngIf="amt && IsCommission == 0">
                              <p><b>Fee(USD)</b></p>
                              <p>{{commissionFee|number}}
                            </div>
                            <div class="col-3 text-left" *ngIf="amt && IsCommission == 0">
                              <p><b>Net Amount(USD)</b></p>
                              <p>{{commissionTotal|number}}
                            </div>
                            <div class="col-3 text-left" *ngIf="amt && show == 3 && IsCommission == 0">
                              <p><b>Amount Charged(NGN)</b></p>
                              <p>{{ActualAmount|number}}</p>
                            </div>
                          </div>
                        </div>-->


                        <!-- <div class="col-12">

                          <mat-form-field>
                            <input type="text" matInput placeholder="Enter Full Card Number" formControlName="CardNo"
                                   minlength="19" maxlength="19" (blur)="transform()" Numberonly
                                   required />
                            <mat-error *ngIf="submitted && f.CardNo.errors">
                              Enter Full Card Number
                            </mat-error>
                          </mat-form-field>


                        </div>

                        <div class="col-12">
                          <mat-form-field class="example-full-width">
                            <input matInput placeholder="Account Description (eg:Kofi's account)"
                                   formControlName="Comment" maxlength="200" />
                          </mat-form-field>
                        </div>-->
                      <!--</div>

                    </div>
                    <div class="col-12">
                      <button class="primary-btn" type="submit" style="margin-top: 20px;"> ADD MONEY</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-12 mt-4">
            <div class="pay-detail text-center">
              <div class="icon_wrap">
                <i class="icon-payment_secure"></i>
              </div>
              <span class="ng-binding">Your payment details are secured</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>-->
